import { app } from '../app/app.js';
import { assert } from '../app/logger.js';
import { PopupButtonControl } from '../controls/popup_button_control.js';
import { ReportDialog } from '../controls/report_dialog.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { ReviewDialog } from './review_dialog.js';
import { ReviewDeleteDialog } from './review_delete_dialog.js';

/**
 * Review menu control.
 */
class ReviewMenuControl extends PopupButtonControl {
  constructor() {
    super();

    this.img = '/images/app_icons.svg#menu_vertical';
    this.name = 'Actions';

    listenToEvent(this, 'itemselect', ev => this[`on${ev.detail?.type}`]?.());
  }

  initialize() {
    super.initialize();
    this.boxElement.addEventListener('click', ev => ev.preventDefault(), {
      capture: true,
    });
  }

  setData(review) {
    assert(review, `[trip-menu-control] no data to set`);

    this.#review = review;

    let items = [];
    if (this.#review.canEdit) {
      items.push({
        img: '/images/app_icons.svg#edit',
        name: 'Edit',
        title: 'Edit review',
        type: 'edit',
      });
    }
    if (this.#review.canDelete) {
      items.push({
        img: '/images/app_icons.svg#waste',
        name: 'Delete',
        title: 'Delete review',
        type: 'delete',
      });
    } else {
      items.push({
        img: '/images/app_icons.svg#spam',
        name: 'Report',
        title: 'Report review',
        type: 'report',
      });
    }
    this.setItems(items);
  }

  onedit() {
    return ReviewDialog.show({
      data: this.#review,
      onaccept: reviewData => this.#review.loc?.changeReview(reviewData),
    });
  }

  ondelete() {
    return ReviewDeleteDialog.show({
      onaccept: () => this.#review.loc?.deleteReview(this.#review),
    });
  }

  onreport() {
    return ReportDialog.show({
      data: {
        detailsData: this.#review,
        detailsMarkup: 'the review',
      },
      onaccept: ({ data, message }) =>
        app.contactUs({
          subject: `Report '${data.headline}':${data.id} review`,
          message: `${message}. Review: ${data.text}`,
        }),
    });
  }

  static tagName = 'review-menu-control';
  static get selectors() {
    return {
      EditMenuItem: `[type=edit]`,
      DeleteMenuItem: `[type=delete]`,
      ReportMenuItem: `[type=report]`,
    };
  }

  #review;
}

ReviewMenuControl.defineCustomElement();

export { ReviewMenuControl };
